<div
  class="signature-view"
  [class.signature-view--large]="isNotSelectedSignature$ | async"
  [attr.data-testid]="dataTestId"
  >
  @if (signature) {
    @if (imageTypeProvided) {
      <img
        [src]="signature | safeResourceUrl"
        class="signature-view__image"
        data-testid="signature-image"
        alt=""
        data-private
        />
    }
    @if (!imageTypeProvided) {
      <img
        [src]="'data:image/png;base64,' + signature"
        class="signature-view__image"
        data-testid="signature-image"
        alt=""
        data-private
        />
    }
  } @else {
    <span class="signature-view__placeholder-text">{{ placeholderText }}</span>
  }
</div>
